/**
 * @generated SignedSource<<2363032423918839432b9a59af30a890>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterArtSize_filters$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilterArtSize_filters">;
  readonly " $fragmentType": "SbRespRefineMenuFilterArtSize_filters";
}>;
export type SbRespRefineMenuFilterArtSize_filters$key = ReadonlyArray<{
  readonly " $data"?: SbRespRefineMenuFilterArtSize_filters$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuFilterArtSize_filters">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbRespRefineMenuFilterArtSize_filters",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterArtSize_filters"
    }
  ],
  "type": "SearchBrowseFilter",
  "abstractKey": null
};

(node as any).hash = "41b687394937b09eeb7c98e65baed9a4";

export default node;
